<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    let cnzzProtocol = ((document.location.protocol === 'https:') ? 'https://' : 'http://')
    document.write(unescape(`%3Cspan id="cnzz_stat_icon_1274031688"%3E%3C/span%3E%3Cscript src="${cnzzProtocol}s13.cnzz.com/z_stat.php%3Fid%3D1274031688" type="text/javascript"%3E%3C/script%3E`))
  },
  watch: {
    '$route' (to, from) {
      if (window._czc) {
        window._czc.push(['_setAutoPageview', false])
        window._czc.push(['_trackPageview', `/#${to.fullPath}`, `/#${from.fullPath}`])
      }
    }
  }
}
</script>

<style>
  #app {
    height: 100%;
  }
  @font-face {
    font-family: PingFangXi;
    src: url("assets/font/PingFang_Xi.ttf");
  }
  #cnzz_stat_icon_1274031688 {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue